// Estilos compartidos de las pantallas de acceso (login, registro, recuperar
// clave, clave nueva).
//
// Estaban dentro de AuthenticationForm.js. Se extrajeron cuando aparecieron las
// pantallas de recuperación: si cada una define su propio input, terminan
// divergiendo y `npm run validate-theme` deja de ser una garantía y pasa a ser
// una lotería.
//
// Regla del proyecto: cero color hardcodeado. Todo por token de theme.js.

export const serif = '"Instrument Serif", "New York", Georgia, serif';

export const fieldLabelSx = {
  display: "block",
  fontSize: 12,
  fontWeight: 600,
  color: "text.muted",
  mb: 0.85,
  textAlign: "left",
};

export const inputSx = {
  width: "100%",
  fontFamily: "inherit",
  fontSize: 15,
  color: "text.primary",
  backgroundColor: "var(--bg-input)",
  border: "1px solid rgba(var(--fg-rgb),0.16)",
  borderRadius: "11px",
  padding: "13px 15px",
  boxSizing: "border-box",
  outline: "none",
  transition: "all 160ms cubic-bezier(0.22,1,0.36,1)",
  "&::placeholder": { color: "text.faint" },
  "&:focus": {
    borderColor: "var(--color-primary)",
    boxShadow: "0 0 0 3px rgba(var(--color-primary-rgb),0.18)",
  },
  "&:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 1000px var(--bg-input) inset",
    WebkitTextFillColor: "var(--text-primary)",
    caretColor: "var(--text-primary)",
  },
};

export const primaryBtnSx = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: 15,
  borderRadius: "12px",
  py: 1.4,
  color: "var(--text-on-primary)",
  backgroundColor: "var(--color-primary)",
  boxShadow:
    "0 1px 0 rgba(var(--fg-rgb),0.1) inset, 0 12px 32px rgba(var(--color-primary-rgb),0.4)",
  transition: "all 240ms cubic-bezier(0.22,1,0.36,1)",
  "&:hover": {
    backgroundColor: "var(--color-primary-soft)",
    transform: "translateY(-2px)",
    boxShadow:
      "0 1px 0 rgba(var(--fg-rgb),0.1) inset, 0 16px 40px rgba(var(--color-primary-rgb),0.55)",
  },
  "&.Mui-disabled": {
    color: "rgba(var(--fg-rgb),0.4)",
    backgroundColor: "rgba(var(--fg-rgb),0.08)",
    boxShadow: "none",
  },
};

export const ghostBtnSx = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: 14,
  borderRadius: "12px",
  py: 1.2,
  color: "text.primary",
  border: "1px solid rgba(var(--fg-rgb),0.16)",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(var(--fg-rgb),0.06)",
    borderColor: "var(--color-primary-soft)",
  },
  "&.Mui-disabled": { color: "text.faint" },
};

// Bloque de error, con el mismo formato que usa el login para que un médico que
// ya vio uno reconozca el otro.
export const errorSx = {
  color: "error.main",
  mt: 2,
  fontWeight: 600,
  fontSize: 13,
  textAlign: "center",
  lineHeight: 1.45,
};

// El login empieza a sentirse roto a los 8s. Mismo umbral en todas las
// pantallas de acceso.
export const SLOW_REQUEST_MS = 8000;

// Chequeo de forma del correo. La validación real la hace el backend; esto es
// para no dejar apretar el botón con algo que obviamente no es un correo.
export const looksLikeEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || "").trim());
